module.exports = __webpack_public_path__ + "static/img/SPLN.e4411c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/SPLN.png
// module id = Lnlu
// module chunks = 1